import { AccessLevel } from "../../../pojo/Fls";
import { MultiselectModelI } from "../../s25-multiselect/s25.multiselect.component";

export namespace RoleRights {
    /**
     * A right definition from the backend enum
     */
    export interface RightDefinition {
        rightName: string;
        displayName: string;
        category: string;
        description: string;
        readDescription: string;
    }

    /**
     * A contact role
     */
    export interface ContactRole {
        contRoleId: number;
        roleName: string;
        defnState: number;
        sortOrder: number;
    }

    /**
     * A role-right assignment
     */
    export interface RoleRightAssignment {
        contRoleId: number;
        rightName: string;
        accessLevel: AccessLevel;
    }

    /**
     * View model for displaying a right with its role assignments
     */
    export interface RightWithRoles {
        right: RightDefinition;
        roleAssignments: Map<number, AccessLevel>; // roleId -> accessLevel
        roles?: MultiselectModelI;
        editRoles?: MultiselectModelI;
    }

    /**
     * Grouped rights by category for display
     */
    export interface RightsByCategory {
        category: string;
        rights: RightWithRoles[];
    }

    /**
     * Response from /roles endpoint
     */
    export interface RolesResponse {
        roles: ContactRole[];
        count: number;
    }

    /**
     * Combined configuration with right definition and assigned roles
     * Returned from /config endpoint
     */
    export interface RightWithRolesConfig {
        rightName: string;
        displayName: string;
        category: string;
        description: string;
        readDescription?: string; //holds a description for read-only permissions
        roles: RoleWithAccessLevel[];
    }

    /**
     * Role with its access level for a specific right
     */
    export interface RoleWithAccessLevel {
        roleId: number;
        roleName: string;
        accessLevel: AccessLevel;
    }

    export enum RoleRightsList {
        SE_BUDGET = "SE_BUDGET",
        SE_ORG_EDIT = "SE_ORG_EDIT",
        SE_ORG_CONTACTS = "SE_ORG_CONTACTS",
        SE_ORG_NEWS = "SE_ORG_NEWS",
        SE_ORG_FILESTORE = "SE_ORG_FILESTORE",
        SE_ORG_SECURITY = "SE_ORG_SECURITY",
        SE_FORMS_MANAGE = "SE_FORMS_MANAGE",
        SE_ELECTION_MANAGE = "SE_ELECTION_MANAGE",
        SE_CURRICULUM_MANAGE = "SE_CURRICULUM_MANAGE",
        SE_EVENT_REQUEST = "SE_EVENT_REQUEST",
        SE_EVENT_REGISTRATION = "SE_EVENT_REGISTRATION",
        SE_EVENT_ATTENDEES = "SE_EVENT_ATTENDEES",
        SE_EVENT_SURVEY = "SE_EVENT_SURVEY",
        SE_ORG_LAYOUTS = "SE_ORG_LAYOUTS",
        SE_ORG_EMAIL = "SE_ORG_EMAIL",
        SE_USER_SEARCH = "SE_USER_SEARCH",
        SE_USER_BULK_EDIT = "SE_USER_BULK_EDIT",
    }

    export type RightsAccess = Record<RoleRightsList, AccessLevel>;
}
